export default "__VITE_ASSET__CG83_zzz__"